<template>
	<div class="camera_wrap">
		<div class="title_area">
			<h3>{{ $t('rtr_pay-payment.scan') }}</h3>
			<span class="modal_close" @click="$emit('close')"></span>
		</div>
		<qrcode-stream @decode="onDecode" @init="onInit" />
	</div>
</template>

<script>
import { QrcodeStream } from 'vue3-qrcode-reader';
export default {
	name: 'QrReader',
	components: {
		QrcodeStream,
	},
	methods: {
		async onInit(promise) {
			try {
				await promise.then(() => {
					this.$emit('onCompleteInit');
				});
			} catch (error) {
				alert(error);
				this.$emit('onError');
			}
		},
		onDecode(result) {
			this.$emit('onCompleteDecode', result);
		},
	},
};
</script>

<style scoped>
.camera_wrap {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100vh;
	z-index: 998;
}
.title_area {
	position: relative;
	padding: 1em;
	width: 100%;
	background-color: #fff;
}
h3 {
	font-size: 24px;
	font-weight: 500;
	line-height: 32px;
	text-align: left;
}
.modal_close {
	position: absolute;
	content: '';
	top: 50%;
	right: 16px;
	transform: translateY(-50%);
	width: 14px;
	height: 14px;
	background-image: url('~@/assets/images/icon/pop_btn_close.png');
	background-size: cover;
	background-position: center;
	cursor: pointer;
}
</style>
